import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { listNav } from "./ListNav.module.scss";

const ListNav = ({ children, className, ...props }) => (
  <nav className={classNames(listNav, className)} {...props}>
    <ol className="m-0 p-0">
      {children}
    </ol>
  </nav>
);

ListNav.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

ListNav.defaultProps = {
  children: null,
  className: ""
};

export default ListNav;
